import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

import {
    Switch,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid,
    TableBody,
    Table,
    TableContainer,
    TableRow,
    TableCell,
    Avatar,
    colors
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        backgroundColor: colors.grey[200],
        width: "50%",
        height: "50%"
    },
    fieldset: {
        minWidth: 950,
        maxWidth: 900
    }
}));

const Device = ({ item, open, closeEdition, updateValues, dependencies }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Dispositivo
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                name: Yup.string().max(50).required('Nome é obrigatório'),
                                description: Yup.string().max(100).required('Descrição é o obrigatória'),
                                mac: Yup.string().max(20).required('Identificador MAC é o obrigatória'),
                                frequency: Yup.number().min(1).max(60000).required('Frequência Dados é o obrigatória'),
                                timeOut: Yup.number().min(1).max(60000).required('Timeout Dados é o obrigatória'),
                                telemetry: Yup.number().min(1).max(60000).required('Frequência Telemetria é o obrigatória'),
                                update: Yup.number().min(1).max(60000).required('Timeout Telemetria é o obrigatória'),
                                firmware: Yup.string().max(100).required('Versão do Firmware é o obrigatória'),
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Grid
                                    container
                                    spacing={2}
                                >

                                    <Grid
                                        item
                                        md={6}
                                        xs={6}>
                                        {dependencies.hardwares.map((hardware) => (
                                            (item.type === hardware.code && item.name == hardware.variant) ? (

                                                <Box
                                                    alignItems="center"
                                                    display="flex"
                                                    flexDirection="column"
                                                >
                                                    <TableContainer component={Box}>
                                                        <Table className={classes.table} aria-label="spanning table" size="small" >
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell colSpan={2} align="center">
                                                                        <Avatar className={classes.avatar}
                                                                            variant="rounded"
                                                                            src={'/static/images/hardwares/' + hardware.image}
                                                                        >
                                                                        </Avatar>
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>Hardware</TableCell>
                                                                    <TableCell align="right">{hardware.code}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>Variante</TableCell>
                                                                    <TableCell align="right">{hardware.variant}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>Nome</TableCell>
                                                                    <TableCell align="right">{hardware.name}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>Plataforma</TableCell>
                                                                    <TableCell align="right">{hardware.platform}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>Fabricante</TableCell>
                                                                    <TableCell align="right">{hardware.manufacturer}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>Especificações</TableCell>
                                                                    <TableCell align="left" >
                                                                        {hardware.especifications.map(esp => (
                                                                            <Typography
                                                                                color="textPrimary"
                                                                                variant="h7">
                                                                                {esp} &nbsp;
                                                                            </Typography>
                                                                        ))}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow >
                                                                    <TableCell>Configurações</TableCell>
                                                                    <TableCell align="left" rowSpan={1} >
                                                                        {hardware.configs.map((cfg, index) => (
                                                                            <Typography
                                                                                color="textPrimary"
                                                                                variant="h7">
                                                                                {cfg.key}: {cfg.value}&ensp;
                                                                            </Typography>
                                                                        ))}
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>

                                                </Box>

                                            ) : ''
                                        ))}

                                    </Grid>


                                    <Grid
                                        item
                                        md={6}
                                        xs={6}>

                                        <Grid
                                            container
                                            spacing={2}
                                        >

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.name && errors.name)}
                                                    required
                                                    fullWidth
                                                    label="Nome"
                                                    margin="normal"
                                                    name="name"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.name}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{ readOnly: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.description && errors.description)}
                                                    fullWidth
                                                    required
                                                    label="Descrição"
                                                    rows={4}
                                                    multiline
                                                    margin="none"
                                                    name="description"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.description}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.mac && errors.mac)}
                                                    fullWidth
                                                    required
                                                    label="Identificador MAC"
                                                    margin="none"
                                                    name="mac"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.mac}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={6}>
                                                <TextField
                                                    error={Boolean(touched.mei && errors.mei)}
                                                    fullWidth
                                                    label="Sim Card"
                                                    margin="none"
                                                    name="mei"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.mei}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={6}>
                                                <TextField
                                                    error={Boolean(touched.apn && errors.apn)}
                                                    fullWidth
                                                    label="Operadora"
                                                    margin="none"
                                                    name="apn"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.apn}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={6}>
                                                <TextField
                                                    error={Boolean(touched.frequency && errors.frequency)}
                                                    fullWidth
                                                    required
                                                    label="Frequência Dados (mim)"
                                                    margin="none"
                                                    name="frequency"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.frequency}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={6}>
                                                <TextField
                                                    error={Boolean(touched.timeOut && errors.timeOut)}
                                                    fullWidth
                                                    required
                                                    label="Timeout Dados (min)"
                                                    margin="none"
                                                    name="timeOut"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.timeOut}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={6}>
                                                <TextField
                                                    error={Boolean(touched.telemetry && errors.telemetry)}
                                                    fullWidth
                                                    required
                                                    label="Frequência Telemetria (min)"
                                                    margin="none"
                                                    name="telemetry"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.telemetry}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={6}>
                                                <TextField
                                                    error={Boolean(touched.update && errors.update)}
                                                    fullWidth
                                                    required
                                                    label="Timeout Telemetria (min)"
                                                    margin="none"
                                                    name="update"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.update}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={6}>
                                                <TextField
                                                    error={Boolean(touched.firmware && errors.firmware)}
                                                    fullWidth
                                                    required
                                                    label="Firmware"
                                                    margin="none"
                                                    name="firmware"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.firmware}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>


                                            <Grid
                                                item
                                                md={6}
                                                xs={6}>

                                                <Grid
                                                    container
                                                    alignItems='baseline'>

                                                    <Grid
                                                        item>
                                                        <Switch
                                                            checked={values.enabled}
                                                            onChange={handleChange}
                                                            name="enabled" />
                                                    </Grid>

                                                    <Grid
                                                        item>
                                                        <Typography variant="h6">
                                                            Habiltar / Desabilitar Dispositivo
                                                        </Typography>

                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </Grid>
                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Device;
